import { render, staticRenderFns } from "./SeleccionarOS.vue?vue&type=template&id=dc13a2d4&scoped=true"
import script from "./SeleccionarOS.vue?vue&type=script&lang=js"
export * from "./SeleccionarOS.vue?vue&type=script&lang=js"
import style0 from "./SeleccionarOS.vue?vue&type=style&index=0&id=dc13a2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc13a2d4",
  null
  
)

export default component.exports